/* tslint:disable:max-classes-per-file */
import { BotId } from "../../global/models/models";
import { DefaultText, ReplyParsed } from "../backend/reply-parsed";
import { DE_FORM } from "./conversation-files/de-conversation";
import { UA_FORM } from "./conversation-files/ua-conversation";

export interface OfflineResponse {
    message: string;
    sessionId: string;
    conversationId: string;
    botId?: BotId;
}

export class OfflineBackendFA {
    message(messageId: string, lang: string): ReplyParsed {
        const response: ReplyParsed = lang === 'ua' ? UA_FORM[messageId] : DE_FORM[messageId];
        if(response)
            return response;
        else
            return this.sendFailureResFA();
    }

    private sendFailureResFA(): ReplyParsed {
        const message: DefaultText = {
            type: "defaultText",
            text: "Hier ist etwas schief gelaufen, bitte versuchen Sie es erneut.",
            bubbleId: "1",
            feedback: false,
        };
        return {
            messages: [message],
            answerBy: {
                type: "textInput",
                placeholder: "default",
            },
            botId: "FORM",
        };
    }
}

